import { Module, VuexModule, Mutation } from 'vuex-module-decorators';
import store from '@/stores';
import Client from '@/domain/models/Client';
import StatusEnum from '@/domain/enums/StatusEnum';

const defaultCustomerObject: Client = {
  id: '',
  companyName: '',
  tradeName: '',
  cnpj: '',
  address: '',
  complement: '',
  city: '',
  neighbourhood: '',
  state: '',
  phone: '',
  invoiceMail: '',
  financialMail1: '',
  financialName1: '',
  financialName2: '',
  sector: '',
  district: '',
  group: '',
  subGroup: '',
  deadline: '',
  limit: null,
  balanceDue: null,
  risk: '',
  clientClass: '',
  firstPurchase: '',
  lastPurchase: '',
  notes: '',
  companyId: 0,
  completeBankName: '',
  ddd: '',
  store: '',
  stateRegistration: '',
  situation: StatusEnum.ACTIVE,
};

@Module({
  dynamic: true,
  namespaced: true,
  name: 'client',
  store,
})
export default class ClientModule extends VuexModule {
  public clientLoading: boolean = true;
  public client: Client = { ...defaultCustomerObject };

  @Mutation
  public setClient(client: Client): void {
    this.client = client;
  }

  @Mutation
  public setClientLoading(state: boolean): void {
    this.clientLoading = state;
  }

  @Mutation
  public setPaymentCondition(value: string): void {
    this.client.deadline = value;
  }

  @Mutation resetCustomerStore(): void {
    this.client = { ...defaultCustomerObject };
  }
}
